var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C7.44772 2 7 2.44772 7 3V4H6C4.34315 4 3 5.34315 3 7V9V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V9V7C21 5.34314 19.6569 4 18 4H17V3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3V4H9V3C9 2.44772 8.55228 2 8 2ZM16 6H8H6C5.44772 6 5 6.44772 5 7V8H19V7C19 6.44772 18.5523 6 18 6H16ZM5 19V10H19V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19ZM11.2426 11.8283C11.4885 11.1049 12.5115 11.1049 12.7574 11.8283L13.2984 13.4197H14.9456C15.7293 13.4197 16.0456 14.4297 15.4019 14.8767L14.1008 15.7803L14.6172 17.2994C14.8656 18.0302 14.0373 18.6542 13.4034 18.214L12 17.2393L10.5966 18.214C9.96267 18.6542 9.13443 18.0302 9.38283 17.2994L9.89919 15.7803L8.59808 14.8767C7.95439 14.4297 8.27072 13.4197 9.05442 13.4197H10.7016L11.2426 11.8283Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarStar);
export default __webpack_public_path__ + "static/media/calendar_star.69b8eb87df4ea42f8ddac999819236e4.svg";
export { ForwardRef as ReactComponent };